<ion-app>
  <!-- Pages render here -->
  <ion-router-outlet></ion-router-outlet>
</ion-app>
